import moment from "moment-timezone";

export const localeCompare = (prop) => (a, b) => a[prop].localeCompare(b[prop]);

// alpha & beta users
export const USERS = {
  beta: [
    "highway65",
    "klsuradio",
    "kcsufm",
    "utaradio",
    "wodu",
    "wloy",
    "kanm",
  ],
  alpha: ["test-bounce-4@makeomatic.ru"],
};

export const INVITATION_ROLES = [
  { name: "group_admin" },
  { name: "admin" }
];
// roles
export const ROLES = [
  {
    suggestions: [
      {
        id: "admin",
        text: "Admin",
      },
      {
        id: "dj",
        text: "DJ",
      },
      {
        id: "participant",
        text: "Participant",
      },
    ],
  },
];

export const MEMBER_ROLES = {
  admin: "Admin",
  dj: "DJ",
};

export const ACL_ROLES = {
  USER: "user",
  ADMIN: "admin",
  DJ: "dj",
  ROOT: "root",
  RESELLER: /^reseller-(.+)$/,
};

export const INVERT_TREE_GENRES = {};
export const CACHE_TOKEN = "myyiy2NTAufjjuY44yFamRihSP7ShaO5ViHdz_8m";
export const TIMEZONES = moment.tz.names();

export const HUMAN_TIMEZONES = {
  "American Samoa (GMT-11)": "US/Samoa",
  "Hawaii Time (GMT-10)": "US/Hawaii",
  "Alaska Time (GMT-9)": "US/Alaska",
  "Pacific Time (GMT-8)": "US/Pacific",
  "Mountain Time - AZ (GMT-7)": "US/Arizona",
  "Mountain Time (GMT-7)": "US/Mountain",
  "Central Time (GMT-6)": "US/Central",
  "Eastern Time (GMT-5)": "US/Eastern",
  "Jamaican Time (GMT-5)": "America/Jamaica",
  "Atlantic Time (GMT-04)": "America/Halifax",
  "Caracas (GMT-04:30)": "America/Caracas",
  "Asuncion (GMT-04)": "America/Asuncion",
  "Atlantic Time (GMT-04)": "America/Halifax",
  "Cuiaba (GMT-04)": "America/Cuiaba",
  "Georgetown (GMT-04)": "America/Guyana",
  "La Paz (GMT-04)": "America/Guyana",
  "Manaus (GMT-04)": "America/Guyana",
  "San Juan (GMT-04)": "America/Guyana",
  "Santiago (GMT-04)": "America/Santiago",
  "Newfoundland (GMT-03:30)": "America/St_Johns",
  "Brasilia (GMT-03)": "America/Sao_Paulo",
  "Buenos Aires (GMT-03)": "America/Argentina/Buenos_Aires",
  "Cayenne, Fortaleza (GMT-03)": "America/Fortaleza",
  "Greenland (GMT-03)": "America/Godthab",
  "Montevideo (GMT-03)": "America/Montevideo",
  "Salvador (GMT-03)": "America/Bahia",
  "Mid-Atlantic - Old (GMT-02)": "Etc/GMT+2",
  "Azores (GMT-01)": "Atlantic/Azores",
  "Cape Verde Is. (GMT-01)": "Atlantic/Cape_Verde",
  "Casablanca (GMT +1)": "Africa/Casablanca",
  "Edinburgh, London (GMT +0)": "Europe/London",
  "Dublin, Lisbon (GMT +0)": "Europe/Lisbon",
  "Monrovia, Reykjavik (GMT +0)": "Africa/Monrovia",
  "Amsterdam (GMT+01)": "Europe/Amsterdam",
  "Berlin (GMT+01)": "Europe/Amsterdam",
  "Bern (GMT+01)": "Europe/Amsterdam",
  "Rome (GMT+01)": "Europe/Amsterdam",
  "Stockholm (GMT+01)": "Europe/Amsterdam",
  "Vienna (GMT+01)": "Europe/Amsterdam",
  "Belgrade (GMT+01)": "Europe/Belgrade",
  "Bratislava (GMT+01)": "Europe/Belgrade",
  "Budapest (GMT+01)": "Europe/Belgrade",
  "Ljubljana (GMT+01)": "Europe/Belgrade",
  "Prague (GMT+01)": "Europe/Belgrade",
  "Brussels (GMT+01)": "Europe/Brussels",
  "Copenhagen (GMT+01)": "Europe/Brussels",
  "Madrid (GMT+01)": "Europe/Brussels",
  "Paris (GMT+01)": "Europe/Brussels",
  "Sarajevo (GMT+01)": "Europe/Sarajevo",
  "Skopje (GMT+01)": "Europe/Sarajevo",
  "Warsaw (GMT+01)": "Europe/Sarajevo",
  "Zagreb (GMT+01)": "Europe/Sarajevo",
  "W. Central Africa Time (GMT+01)": "Africa/Lagos",
  "GTB Time (GMT+02)": "Europe/Athens",
  "Middle East Time (GMT+02)": "Asia/Beirut",
  "Egypt Time (GMT+02)": "Africa/Cairo",
  "Syria Time (GMT+02)": "Asia/Damascus",
  "E. Europe Time (GMT+02)": "Europe/Athens",
  "South Africa Time (GMT+02)": "Africa/Johannesburg",
  "FLE Time (GMT+02)": "Europe/Helsinki",
  "Turkey Time (GMT+03)": "Europe/Istanbul",
  "Israel Time (GMT+02)": "Asia/Jerusalem",
  "Libya Time (GMT+02)": "Africa/Tripoli",
  "Jordan Time (GMT+03)": "Asia/Amman",
  "Arabic Time (GMT+03)": "Asia/Baghdad",
  "Kaliningrad Time (GMT+02)": "Europe/Kaliningrad",
  "Arab Time (GMT+03)": "Asia/Kuwait",
  "E. Africa Time (GMT+03)": "Africa/Nairobi",
  "Moscow Time (GMT+03)": "Europe/Moscow",
  "Samara Time (GMT+04)": "Europe/Samara",
  "Iran Time (GMT+03:30)": "Asia/Tehran",
  "Arabian Time (GMT+04)": "Asia/Dubai",
  "Azerbaijan Time (GMT+04)": "Asia/Baku",
  "Mauritius Time (GMT+04)": "Indian/Mauritius",
  "Georgian Time (GMT+04)": "Asia/Tbilisi",
  "Caucasus Time (GMT+04)": "Asia/Yerevan",
  "Afghanistan Time (GMT+04:30)": "Asia/Kabul",
  "West Asia Time (GMT+05)": "Asia/Ashgabat",
  "Yekaterinburg Time (GMT+05)": "Asia/Yekaterinburg",
  "Pakistan Time (GMT+05)": "Asia/Karachi",
  "India Time (GMT+05:30)": "Asia/Kolkata",
  "Sri Lanka Time (GMT+05:30)": "Asia/Colombo",
  "Nepal Time (GMT+05:45)": "Asia/Kathmandu",
  "Central Asia Time (GMT+06)": "Asia/Almaty",
  "Bangladesh Time (GMT+06)": "Asia/Dhaka",
  "Myanmar Time (GMT+06:30)": "Asia/Rangoon",
  "SE Asia Time (GMT+07)": "Asia/Bangkok",
  "N. Central Asia Time (GMT+07)": "Asia/Novosibirsk",
  "China Time (GMT+08)": "Asia/Shanghai",
  "North Asia Time (GMT+08)": "Asia/Krasnoyarsk",
  "Singapore Time (GMT+08)": "Asia/Singapore",
  "W. Australia Time (GMT+08)": "Australia/Perth",
  "Taipei Time (GMT+08)": "Asia/Taipei",
  "Ulaanbaatar Time (GMT+08)": "Asia/Ulaanbaatar",
  "North Asia East Time (GMT+08)": "Asia/Irkutsk",
  "Japan Time (GMT+09)": "Asia/Tokyo",
  "Korea Time (GMT+09)": "Asia/Seoul",
  "Cen. Australia Time (GMT+09:30)": "Australia/Adelaide",
  "AUS Central Time (GMT+09:30)": "Australia/Darwin",
  "E. Australia Time (GMT+10)": "Australia/Brisbane",
  "AUS Eastern Time (GMT+10)": "Australia/Melbourne",
  "West Pacific Time (GMT+10)": "Pacific/Guam",
  "Tasmania Time (GMT+10)": "Australia/Hobart",
  "Yakutsk Time (GMT+09)": "Asia/Yakutsk",
  "Central Pacific Time (GMT+11)": "Pacific/Guadalcanal",
  "Vladivostok Time (GMT+11)": "Asia/Vladivostok",
  "New Zealand Time (GMT+12)": "Pacific/Auckland",
  "GMT+12 (GMT+12)": "Pacific/Funafuti",
  "Fiji Time (GMT+12)": "Pacific/Fiji",
  "Magadan Time (GMT+12)": "Asia/Magadan",
  "Kamchatka Time (GMT+12)": "Asia/Kamchatka",
  "Tonga Time (GMT+13)": "Pacific/Tongatapu",
  "Samoa Time (GMT+13)": "Pacific/Apia"
};


export const ICAL_TIMEZONES = {
  "US/Samoa": "Pacific/Pago_Pago",
  "US/Hawaii": "Pacific/Honolulu",
  "US/Alaska": "America/Anchorage",
  "US/Pacific": "America/Los_Angeles",
  "US/Arizona": "America/Phoenix",
  "US/Mountain": "America/Denver",
  "US/Central": "America/Chicago",
  "US/Eastern": "America/New_York",
  "America/Jamaica": "America/Jamaica",
  "America/Halifax": "America/Halifax",
  "America/Caracas": "America/Caracas",
  "America/Asuncion": "America/Asuncion",
  "America/Cuiaba": "America/Cuiaba",
  "America/Guyana": "America/Guyana",
  "America/La_Paz": "America/La_Paz",
  "America/Manaus": "America/Manaus",
  "America/Puerto_Rico": "America/Puerto_Rico",
  "America/Santiago": "America/Santiago",
  "America/St_Johns": "America/St_Johns",
  "America/Sao_Paulo": "America/Sao_Paulo",
  "America/Argentina/Buenos_Aires": "America/Argentina/Buenos_Aires",
  "America/Fortaleza": "America/Fortaleza",
  "America/Godthab": "America/Godthab",
  "America/Montevideo": "America/Montevideo",
  "America/Bahia": "America/Bahia",
  "Etc/GMT+2": "Etc/GMT+2",
  "Atlantic/Azores": "Atlantic/Azores",
  "Atlantic/Cape_Verde": "Atlantic/Cape_Verde",
  "Africa/Casablanca": "Africa/Casablanca",
  "Europe/London": "Europe/London",
  "Europe/Lisbon": "Europe/Lisbon",
  "Africa/Monrovia": "Africa/Monrovia",
  "Europe/Amsterdam": "Europe/Amsterdam",
  "Europe/Berlin": "Europe/Berlin",
  "Europe/Bern": "Europe/Zurich",
  "Europe/Rome": "Europe/Rome",
  "Europe/Stockholm": "Europe/Stockholm",
  "Europe/Vienna": "Europe/Vienna",
  "Europe/Belgrade": "Europe/Belgrade",
  "Europe/Bratislava": "Europe/Bratislava",
  "Europe/Budapest": "Europe/Budapest",
  "Europe/Ljubljana": "Europe/Ljubljana",
  "Europe/Prague": "Europe/Prague",
  "Europe/Brussels": "Europe/Brussels",
  "Europe/Copenhagen": "Europe/Copenhagen",
  "Europe/Madrid": "Europe/Madrid",
  "Europe/Paris": "Europe/Paris",
  "Europe/Sarajevo": "Europe/Sarajevo",
  "Europe/Skopje": "Europe/Skopje",
  "Europe/Warsaw": "Europe/Warsaw",
  "Europe/Zagreb": "Europe/Zagreb",
  "Africa/Lagos": "Africa/Lagos",
  "Europe/Athens": "Europe/Athens",
  "Asia/Beirut": "Asia/Beirut",
  "Africa/Cairo": "Africa/Cairo",
  "Asia/Damascus": "Asia/Damascus",
  "Africa/Johannesburg": "Africa/Johannesburg",
  "Europe/Helsinki": "Europe/Helsinki",
  "Europe/Istanbul": "Europe/Istanbul",
  "Asia/Jerusalem": "Asia/Jerusalem",
  "Africa/Tripoli": "Africa/Tripoli",
  "Asia/Amman": "Asia/Amman",
  "Asia/Baghdad": "Asia/Baghdad",
  "Europe/Kaliningrad": "Europe/Kaliningrad",
  "Asia/Kuwait": "Asia/Kuwait",
  "Africa/Nairobi": "Africa/Nairobi",
  "Europe/Moscow": "Europe/Moscow",
  "Europe/Samara": "Europe/Samara",
  "Asia/Tehran": "Asia/Tehran",
  "Asia/Dubai": "Asia/Dubai",
  "Asia/Baku": "Asia/Baku",
  "Indian/Mauritius": "Indian/Mauritius",
  "Asia/Tbilisi": "Asia/Tbilisi",
  "Asia/Yerevan": "Asia/Yerevan",
  "Asia/Kabul": "Asia/Kabul",
  "Asia/Ashgabat": "Asia/Ashgabat",
  "Asia/Yekaterinburg": "Asia/Yekaterinburg",
  "Asia/Karachi": "Asia/Karachi",
  "Asia/Kolkata": "Asia/Kolkata",
  "Asia/Colombo": "Asia/Colombo",
  "Asia/Kathmandu": "Asia/Kathmandu",
  "Asia/Almaty": "Asia/Almaty",
  "Asia/Dhaka": "Asia/Dhaka",
  "Asia/Rangoon": "Asia/Yangon",
  "Asia/Bangkok": "Asia/Bangkok",
  "Asia/Novosibirsk": "Asia/Novosibirsk",
  "Asia/Shanghai": "Asia/Shanghai",
  "Asia/Krasnoyarsk": "Asia/Krasnoyarsk",
  "Asia/Singapore": "Asia/Singapore",
  "Australia/Perth": "Australia/Perth",
  "Asia/Taipei": "Asia/Taipei",
  "Asia/Ulaanbaatar": "Asia/Ulaanbaatar",
  "Asia/Irkutsk": "Asia/Irkutsk",
  "Asia/Tokyo": "Asia/Tokyo",
  "Asia/Seoul": "Asia/Seoul",
  "Australia/Adelaide": "Australia/Adelaide",
  "Australia/Darwin": "Australia/Darwin",
  "Australia/Brisbane": "Australia/Brisbane",
  "Australia/Melbourne": "Australia/Melbourne",
  "Pacific/Guam": "Pacific/Guam",
  "Australia/Hobart": "Australia/Hobart",
  "Asia/Yakutsk": "Asia/Yakutsk",
  "Pacific/Guadalcanal": "Pacific/Guadalcanal",
  "Asia/Vladivostok": "Asia/Vladivostok",
  "Pacific/Auckland": "Pacific/Auckland",
  "Pacific/Funafuti": "Pacific/Funafuti",
  "Pacific/Fiji": "Pacific/Fiji",
  "Asia/Magadan": "Asia/Magadan",
  "Asia/Kamchatka": "Asia/Kamchatka",
  "Pacific/Tongatapu": "Pacific/Tongatapu",
  "Pacific/Apia": "Pacific/Apia"
};



export const emojis = [
  '\u{1F600}', '\u{1F601}', '\u{1F602}', '\u{1F923}', '\u{1F609}', 
  '\u{1F60D}', '\u{1F618}', '\u{1F617}', '\u{1F619}', '\u{1F61A}', 
  '\u{1F642}', '\u{1F917}', '\u{1F914}', '\u{1F910}', '\u{1F928}', 
  '\u{1F610}', '\u{1F611}', '\u{1F636}', '\u{1F60F}', '\u{1F612}', 
  '\u{1F644}', '\u{1F62C}', '\u{1F62E}', '\u{1F910}', '\u{1F911}', 
  '\u{1F917}', '\u{1F924}', '\u{1F92F}', '\u{1F92A}', '\u{1F609}', 
  '\u{1F60D}', '\u{2764}\u{FE0F}', '\u{1F496}', '\u{1F495}', '\u{1F49A}',
  '\u{1F49C}', '\u{1F49B}', '\u{1F5A4}', '\u{1F60E}', '\u{1F929}'
];


export const POLL_STATES = {
  0: "created",
  1: "active",
  2: "ended",
  3: "ended",
  4: "archived",
};

export const CONTEST_STATES = {
  0: "created",
  1: "active",
  2: "stopped",
  3: "ended",
  4: "archived",
};

export const MAP_INFO = {
  url: "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}.png",
  // eslint-disable-next-line max-len
  attribution:
    "&copy; <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>, &copy; <a href='https://carto.com/attribution'>CARTO</a>",
};

// appmetrica & analytics
export const METRIKA_APP_ID = 353079;
export const APP_TIMEZONE = "Europe/Moscow";
export const START_DATE = "2017-02-02";

// Minimal number of days when custom
// period should be visualised in hours
export const MIN_DAYS = 2;

export const KEYS = {
  totalListeners: "Total Listeners",
  totalLogged: "Total Logged",
  totalSessions: "Total Sessions",
  totalMessages: "Total Messages",
  totalActivity: "Total Activity",
  favoritesAdd: "Favorites Add",
  favoritesRemove: "Favorites Remove",
  totalFavorites: "Station Favorites",
  listeners: "Listeners",
  loggedListeners: "Logged Listeners",
  sessions: "Sessions",
  messages: "Messages",
  region: "Region",
  duration: "Duration",
  gender: "Gender",
  age: "Age",
  appSessionStarted: "App Session Started",
  listeningTimeForSession: "Listening Time For Session",
  mainLineChart: "Main",
};

export const KEY_GROUPS = {
  totals: [
    KEYS.totalActivity,
    KEYS.totalSessions,
    KEYS.totalMessages,
    KEYS.totalListeners,
    KEYS.totalLogged,
  ],
  period: [
    KEYS.mainLineChart,
    KEYS.messages,
    KEYS.duration,
    KEYS.age,
    KEYS.region,
    KEYS.gender,
  ],
  mainLineChart: [KEYS.listeners, KEYS.loggedListeners, KEYS.sessions],
  messagesLineChart: [KEYS.messages],
};

export const BIG_QUERY_EVENTS = {
  [KEYS.appSessionStarted]: {
    eventLabel: "App Session Started",
  },
  [KEYS.listeningTimeForSession]: {
    eventLabel: "Listening Time for Session",
  },
};

export const METRIKA_EVENTS = {
  // totals
  [KEYS.totalListeners]: {
    eventLabel: "Main - Open Station",
    metrics: "ym:ce:users",
    total: true,
  },
  [KEYS.totalLogged]: {
    eventLabel: "Main - Open Station",
    metrics: "ym:ce:users",
    additionalParams:
      "ym:ce:paramsLevel1=='userLoggedIn' AND ym:ce:paramsLevel2=='true'",
    total: true,
  },
  [KEYS.totalSessions]: {
    eventLabel: "Station - Start Playback",
    metrics: "ym:ce:clientEvents",
    total: true,
  },
  [KEYS.totalMessages]: {
    eventLabel: "Chat - Send Message",
    metrics: "ym:ce:clientEvents",
    total: true,
  },
  [KEYS.totalActivity]: {
    metrics: "ym:ce:clientEvents",
    total: true,
  },
  [KEYS.favoritesAdd]: {
    eventLabel: "Station - Add to Favorites",
    metrics: "ym:ce:users",
    total: true,
  },
  [KEYS.favoritesRemove]: {
    eventLabel: "Station - Remove from Favorites",
    metrics: "ym:ce:users",
    total: true,
  },
  // period
  [KEYS.listeners]: {
    eventLabel: "Main - Open Station",
    metrics: "ym:ce:users",
  },
  [KEYS.loggedListeners]: {
    eventLabel: "Main - Open Station",
    metrics: "ym:ce:users",
    additionalParams:
      "ym:ce:paramsLevel1=='userLoggedIn' AND ym:ce:paramsLevel2=='true'",
  },
  [KEYS.sessions]: {
    eventLabel: "Station - Start Playback",
    metrics: "ym:ce:clientEvents",
  },
  [KEYS.messages]: {
    eventLabel: "Chat - Send Message",
    metrics: "ym:ce:clientEvents",
  },
  [KEYS.region]: {
    eventLabel: "Main - Open Station",
    metrics: "ym:ce:users",
    dimensions: "ym:ce:regionCity,ym:ce:regionCountry",
    // group: 'all',
  },
  [KEYS.duration]: {
    eventLabel: "Station - Stop Playback",
    dimensions: "ym:ce:eventLabel,ym:ce:paramsLevel1,ym:ce:paramsLevel2",
    additionalParams:
      "ym:ce:paramsLevel1=='duration' and ym:ce:paramsLevel2>0 and ym:ce:users>0",
    metrics: "ym:ce:clientEvents",
  },
  [KEYS.gender]: {
    eventLabel: "Main - Open Station",
    dimensions: "ym:ce:eventLabel,ym:ce:paramsLevel1,ym:ce:paramsLevel2",
    additionalParams: "ym:ce:paramsLevel1=='userGender'",
    metrics: "ym:ce:users",
  },
  [KEYS.age]: {
    eventLabel: "Main - Open Station",
    dimensions: "ym:ce:eventLabel,ym:ce:paramsLevel1,ym:ce:paramsLevel2",
    additionalParams: "ym:ce:paramsLevel1=='userBirthday'",
    metrics: "ym:ce:users",
  },
};

export const TITLES = {
  today: "last 24 hours",
  yesterday: "yesterday",
  week: "last week",
  month: "last month",
  year: "last year",
};

export const GROUP_SEGMENTS = {
  today: "hour",
  yesterday: "hour",
  week: "day",
  month: "day",
  year: "day",
  custom: "day",
  customByHours: "hour",
};

export const ADD_UNITS = {
  today: "hours",
  yesterday: "hours",
  week: "days",
  month: "days",
  year: "days",
  custom: "days",
  customByHours: "hours",
};

export const FORMAT_SCHEMAS = {
  today: { from: "YYYY-MM-DD HH:mm:ss", to: "hh:mm a" },
  yesterday: { from: "YYYY-MM-DD HH:mm:ss", to: "hh:mm a" },
  week: { from: "YYYY-MM-DD", to: "YYYY-MM-DD" },
  month: { from: "YYYY-MM-DD", to: "YYYY-MM-DD" },
  year: { from: "YYYY-MM-DD", to: "YYYY-MM-DD" },
  custom: { from: "YYYY-MM-DD", to: "YYYY-MM-DD" },
  customByHours: { from: "YYYY-MM-DD HH:mm:ss", to: "hh:mm a" },
};

export const STATION_GROUPS = {
  "113fm": 'RadioMAX',
  radiofx: "RadioFX",
  radiomax: "RadioMAX",
  cjru: "Ryerson Radio",
  khts: "KHTS Radio",
  iftnm: "Infotainment Radio",
};
export const STATION_GROUPS_1 = {
  radiofx: "RadioFX",
  radiomax: "RadioMAX",
  cjru: "Ryerson Radio",
  khts: "KHTS Radio",
  iftnm: "Infotainment Radio",
};

export const COUNTRIES = [
  { name: "United States", region: "US" },
  { name: "Canada", region: "CA" },
  { name: "Australia", region: "AU" },
  { name: "Greece", region: "GR" },
  { name: "Italy", region: "IT" },
  { name: "France", region: "FR" },
  { name: "Finland", region: "FI" },
  { name: "Sweden", region: "SE" },
  { name: "Norway", region: "NO" },
  { name: "Spain", region: "ES" },
  { name: "Portugal", region: "PT" },
  { name: "Germany", region: "DE" },
  { name: "Netherlands", region: "NL" },
  { name: "United Kingdom", region: "GB" },
  { name: "Ireland", region: "IE" },
  { name: "Switzerland", region: "CH" },
  { name: "Mexico", region: "MX" },
  { name: "South Africa", region: "ZA" },
  { name: "Chile", region: "CL" },
  { name: "Namibia", region: "NA" },
  { name: "Ukraine", region: "UA" },
  { name: "Curacao", region: "CW" },
  { name: "Trinidad & Tobago", region: "TT" },
  { name: "Puerto Rico", region: "PR" },
  { name: "Jamaica", region: "JM" },
  { name: "Tanzania", region: "TZ" },
  { name: "Cameroon", region: "CM" },
  { name: "Afghanistan", region: "AF" },
  { name: "Albania", region: "AL" },
  { name: "Algeria", region: "DZ" },
  { name: "American Samoa", region: "AS" },
  { name: "Andorra", region: "AD" },
  { name: "Angola", region: "AO" },
  { name: "Anguilla", region: "AI" },
  { name: "Antigua and Barbuda", region: "AG" },
  { name: "Argentina", region: "AR" },
  { name: "Armenia", region: "AM" },
  { name: "Aruba", region: "AW" },
  { name: "Austria", region: "AT" },
  { name: "Azerbaijan", region: "AZ" },
  { name: "Bahamas", region: "BS" },
  { name: "Bahrain", region: "BH" },
  { name: "Bangladesh", region: "BD" },
  { name: "Barbados", region: "BB" },
  { name: "Belarus", region: "BY" },
  { name: "Belgium", region: "BE" },
  { name: "Belize", region: "BZ" },
  { name: "Benin", region: "BJ" },
  { name: "Bermuda", region: "BM" },
  { name: "Bhutan", region: "BT" },
  { name: "Bolivia, Plurinational State of", region: "BO" },
  { name: "Bosnia and Herzegovina", region: "BA" },
  { name: "Botswana", region: "BW" },
  { name: "Brazil", region: "BR" },
  { name: "British Indian Ocean Territory", region: "IO" },
  { name: "Bulgaria", region: "BG" },
  { name: "Burkina Faso", region: "BF" },
  { name: "Burundi", region: "BI" },
  { name: "Cambodia", region: "KH" },
  { name: "Cape Verde", region: "CV" },
  { name: "Cayman Islands", region: "KY" },
  { name: "Central African Republic", region: "CF" },
  { name: "Chad", region: "TD" },
  { name: "China", region: "CN" },
  { name: "Colombia", region: "CO" },
  { name: "Comoros", region: "KM" },
  { name: "Congo", region: "CG" },
  { name: "Democratic Republic of the Congo", region: "CD" },
  { name: "Cook Islands", region: "CK" },
  { name: "Costa Rica", region: "CR" },
  { name: "Côte d'Ivoire", region: "CI" },
  { name: "Croatia", region: "HR" },
  { name: "Cuba", region: "CU" },
  { name: "Curaçao", region: "CW" },
  { name: "Cyprus", region: "CY" },
  { name: "Czech Republic", region: "CZ" },
  { name: "Denmark", region: "DK" },
  { name: "Djibouti", region: "DJ" },
  { name: "Dominica", region: "DM" },
  { name: "Dominican Republic", region: "DO" },
  { name: "Ecuador", region: "EC" },
  { name: "Egypt", region: "EG" },
  { name: "El Salvador", region: "SV" },
  { name: "Equatorial Guinea", region: "GQ" },
  { name: "Eritrea", region: "ER" },
  { name: "Estonia", region: "EE" },
  { name: "Ethiopia", region: "ET" },
  { name: "Falkland Islands (Malvinas)", region: "FK" },
  { name: "Faroe Islands", region: "FO" },
  { name: "Fiji", region: "FJ" },
  { name: "French Polynesia", region: "PF" },
  { name: "Gabon", region: "GA" },
  { name: "Gambia", region: "GM" },
  { name: "Georgia", region: "GE" },
  { name: "Ghana", region: "GH" },
  { name: "Gibraltar", region: "GI" },
  { name: "Greenland", region: "GL" },
  { name: "Grenada", region: "GD" },
  { name: "Guam", region: "GU" },
  { name: "Guatemala", region: "GT" },
  { name: "Guernsey", region: "GG" },
  { name: "Guinea", region: "GN" },
  { name: "Guinea-Bissau", region: "GW" },
  { name: "Haiti", region: "HT" },
  { name: "Honduras", region: "HN" },
  { name: "Hong Kong", region: "HK" },
  { name: "Hungary", region: "HU" },
  { name: "Iceland", region: "IS" },
  { name: "India", region: "IN" },
  { name: "Indonesia", region: "ID" },
  { name: "Iran, Islamic Republic of", region: "IR" },
  { name: "Iraq", region: "IQ" },
  { name: "Isle of Man", region: "IM" },
  { name: "Israel", region: "IL" },
  { name: "Japan", region: "JP" },
  { name: "Jersey", region: "JE" },
  { name: "Jordan", region: "JO" },
  { name: "Kazakhstan", region: "KZ" },
  { name: "Kenya", region: "KE" },
  { name: "Kiribati", region: "KI" },
  { name: "North Korea", region: "KP" },
  { name: "South Korea", region: "KR" },
  { name: "Kuwait", region: "KW" },
  { name: "Kyrgyzstan", region: "KG" },
  { name: "Lao People's Democratic Republic", region: "LA" },
  { name: "Latvia", region: "LV" },
  { name: "Lebanon", region: "LB" },
  { name: "Lesotho", region: "LS" },
  { name: "Liberia", region: "LR" },
  { name: "Libya", region: "LY" },
  { name: "Liechtenstein", region: "LI" },
  { name: "Lithuania", region: "LT" },
  { name: "Luxembourg", region: "LU" },
  { name: "Macao", region: "MO" },
  { name: "Republic of Macedonia", region: "MK" },
  { name: "Madagascar", region: "MG" },
  { name: "Malawi", region: "MW" },
  { name: "Malaysia", region: "MY" },
  { name: "Maldives", region: "MV" },
  { name: "Mali", region: "ML" },
  { name: "Malta", region: "MT" },
  { name: "Marshall Islands", region: "MH" },
  { name: "Martinique", region: "MQ" },
  { name: "Mauritania", region: "MR" },
  { name: "Mauritius", region: "MU" },
  { name: "Micronesia, Federated States of", region: "FM" },
  { name: "Republic of Moldova", region: "MD" },
  { name: "Monaco", region: "MC" },
  { name: "Mongolia", region: "MN" },
  { name: "Montenegro", region: "ME" },
  { name: "Montserrat", region: "MS" },
  { name: "Morocco", region: "MA" },
  { name: "Mozambique", region: "MZ" },
  { name: "Myanmar", region: "MM" },
  { name: "Nauru", region: "NR" },
  { name: "Nepal", region: "NP" },
  { name: "New Zealand", region: "NZ" },
  { name: "Nicaragua", region: "NI" },
  { name: "Niger", region: "NE" },
  { name: "Nigeria", region: "NG" },
  { name: "Niue", region: "NU" },
  { name: "Norfolk Island", region: "NF" },
  { name: "Northern Mariana Islands", region: "MP" },
  { name: "Oman", region: "OM" },
  { name: "Pakistan", region: "PK" },
  { name: "Palau", region: "PW" },
  { name: "Palestinian Territory", region: "PS" },
  { name: "Panama", region: "PA" },
  { name: "Papua New Guinea", region: "PG" },
  { name: "Paraguay", region: "PY" },
  { name: "Peru", region: "PE" },
  { name: "Philippines", region: "PH" },
  { name: "Poland", region: "PL" },
  { name: "Qatar", region: "QA" },
  { name: "Romania", region: "RO" },
  { name: "Russia", region: "RU" },
  { name: "Rwanda", region: "RW" },
  { name: "Saint Kitts and Nevis", region: "KN" },
  { name: "Saint Lucia", region: "LC" },
  { name: "Samoa", region: "WS" },
  { name: "San Marino", region: "SM" },
  { name: "Sao Tome and Principe", region: "ST" },
  { name: "Saudi Arabia", region: "SA" },
  { name: "Senegal", region: "SN" },
  { name: "Serbia", region: "RS" },
  { name: "Seychelles", region: "SC" },
  { name: "Sierra Leone", region: "SL" },
  { name: "Singapore", region: "SG" },
  { name: "Sint Maarten", region: "SX" },
  { name: "Slovakia", region: "SK" },
  { name: "Slovenia", region: "SI" },
  { name: "Solomon Islands", region: "SB" },
  { name: "Somalia", region: "SO" },
  { name: "South Sudan", region: "SS" },
  { name: "Sri Lanka", region: "LK" },
  { name: "Sudan", region: "SD" },
  { name: "Suriname", region: "SR" },
  { name: "Swaziland", region: "SZ" },
  { name: "Syria", region: "SY" },
  { name: "Taiwan", region: "TW" },
  { name: "Tajikistan", region: "TJ" },
  { name: "Thailand", region: "TH" },
  { name: "Togo", region: "TG" },
  { name: "Tokelau", region: "TK" },
  { name: "Tonga", region: "TO" },
  { name: "Tunisia", region: "TN" },
  { name: "Turkey", region: "TR" },
  { name: "Turkmenistan", region: "TM" },
  { name: "Turks and Caicos Islands", region: "TC" },
  { name: "Tuvalu", region: "TV" },
  { name: "Uganda", region: "UG" },
  { name: "United Arab Emirates", region: "AE" },
  { name: "Uruguay", region: "UY" },
  { name: "Uzbekistan", region: "UZ" },
  { name: "Vanuatu", region: "VU" },
  { name: "Venezuela, Bolivarian Republic of", region: "VE" },
  { name: "Viet Nam", region: "VN" },
  { name: "Virgin Islands", region: "VI" },
  { name: "Yemen", region: "YE" },
  { name: "Zambia", region: "ZM" },
  { name: "Zimbabwe", region: "ZW" },
];

// Allow Unicode Apps List for Chat Messages

export const Alias = [
  "kradio",
  "lamexicana",
  "kbzefm",
  "occr",
  "wokb",
  "wiezfm",
  "wwfafm",
  "wtkifm",
  "wslvfm",
  "lapanterafw",
  "lapanterasa",
  "kglafm",
  "wfnofm",
  "pledge radio",
  "jq-99",
  "kapbfm",
  "bscmyx",
  "lacruz",
  "wuuffm",
  "kwkwfm",
  "kmnvfmam",
  "klucfmhd3",
  "cenla",
  "wmbvam",
  "krsyam",
  "krsyfmem",
  "knmzem",
  "knelam",
  "knelfm",
  "kmiqfm",
  "kwldfm",
  "knxrfm",
  "newlifeafrica",
  "vienouvelle",
  "wkeyfm",
  "wsuaam",
  "wttejano",
  "wpxnfm",
  "wvxsfm",
  "wgrt",
  "witglpfm",
  "webyam",
  "lander",
  "piolin",
  "shoboy",
  "stpeters",
];

// List of projects in FireBase dropdown
export const PROJECT_LIST = [
  { projectName: 'Radiofxdev', projectId: 'therange' },
  {projectName: 'RadioFx',projectId: "civic-meridian-130023"},
  {projectName: 'RadioFX 2',projectId: "pullman-radio"},
  {projectName: 'RadioFx 3',projectId: "radiofx3"},
  {projectName: 'RadioFX 4',projectId: "radiofx4"},
  {projectName: 'Radiofx 5',projectId: "radiofx-5"},
  {projectName: 'RadioFX 6',projectId: "radiofx-6"},
  {projectName: 'RadioFX 7',projectId: "radiofx-7"},
  {projectName: 'RadioFX 8',projectId: "radiofx-8"},
  {projectName: 'RadioFX 9',projectId: "radiofx-9"},
  {projectName: 'RadioFX 10',projectId: "radiofx-10"},
  {projectName: 'RadioFX 11',projectId: "radiofx-11"},
  {projectName: 'RadioFx 12',projectId: "radiofx-10-a9278"},
  {projectName: 'RadioFX 13',projectId: "radiofx-11-b7bf3"},
  {projectName: 'RadioFx 14',projectId: "radiofx-14"},
  { projectName: 'Radiofx 15', projectId: 'radiofx-15' },
  { projectName: 'Radiofx 16', projectId: 'radiofx-16' },
  { projectName: 'Radiofx 17', projectId: 'radiofx-17' },
  { projectName: 'Radiofx 18', projectId: 'radiofx-14-8e5c9' },
  { projectName: 'Radiofx 19', projectId: 'radiofx-19' },
  { projectName: 'Radiofx 20', projectId: 'radiofx-20' },
  { projectName: 'Radiofx 21', projectId: 'radiofx21' },
  { projectName: 'Radiofx 22', projectId: 'radiofx-22' },
  { projectName: 'Radiofx 23', projectId: 'radiofx-23' },
  { projectName: 'Radiofx 24', projectId: 'radiofx-24' },
  { projectName: 'Radiofx 25', projectId: 'radiofx-25' },
  { projectName: 'Radiofx 26', projectId: 'radiofx-26' },
  { projectName: 'Radiofx 27', projectId: 'radiofx-27' },
];


// List of projects in FireBase dropdown
export const CLOUDFLARE_BUCKET = { 
  accessKeyId: '34b772016f96b917166b63c634c26d0e', 
  secretAccessKey: '2386062c340a76c37c90a50673b69aa7fdaf7edaed2b95c3e2ab1489db2a3cc8' ,
  bucketName: 'dev-videos' ,
  audioBucketName: 'dev-audios' ,
  region: 'auto' ,
  endpoint: 'https://2e1fb2ad42f1ea632f61f0b8889d2a3a.r2.cloudflarestorage.com',
  audio_bucket_url:'https://pub-33d02a412b4347dba43d759d537e2c65.r2.dev',
  bucket_url: 'https://pub-0eda12b0ea1a4e3eae1cffa349d992e9.r2.dev',
};

export const ignoredAPIs = [
  "/chat/messages/pins-history",
];  